import React from 'react';
import '../../styles/new_job_creation.css'; // Correct path to your CSS file
import imageWebp from '../../assets/image.webp'; // Import the webp image
import penIcon from '../../assets/pen.png'; // Import the pen.png image

const NewJobCreation = () => {
    return (
        <div className="create-job-card">
            <div className="create-job-content">
                <div className="create-job-illustration">
                    <img src={imageWebp} alt="Job Illustration" />
                </div>
                <div className="create-job-text">
                    <h2>Create New Job</h2>
                    <div className="create-job-icon">
                        <img src={penIcon} alt="Pen Icon" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewJobCreation;

